import React, { useEffect, useState } from 'react';
import { t } from 'ttag';
import { useLoading } from '../LoadingContext';

const TimeoutPage = () => {
  const header = document.getElementById('headerLogo');
  const { toggleLoading } = useLoading();

  useEffect(() => {
    document.body.classList.add("dark-theme");
    
    if(header && header.classList) {header.classList.add("feher-logo")}
    
    toggleLoading(false);

    // Cleanup (opcionális, ha eltávolítanád a class-t amikor a komponens unmountolódik)
    return () => {
      document.body.classList.remove("dark-theme");
    };
  }, []);

  const handleBackClick = () => {
    const redirectUrl = localStorage.getItem("redirecturl");
    window.location.replace(`${process.env.PUBLIC_URL}/event/${redirectUrl}`);
  };

  return (
    <div className="landing__section">
      <div className="row" style={{ padding: 20 }}>
        <div className="wrapper col-md-8" style={{ padding: 20 }}>
          <p style={{ fontSize: '1.75rem', textAlign: 'center' }}>
            {t`A rendelkezésre álló idő lejárt, a jegyek fel lettek szabadítva!`}
          </p>
          <p style={{ fontSize: '1.1rem', textAlign: 'center' }}>
            {t`Annak érdekében, hogy a jegyek a lehető legtöbb ember számára hozzáférhetők legyenek, minden rendelés jobb felső sarkában egy időzítőt helyezünk el a fizetési folyamat során. Ha nem fejezi be a rendelést a  megadott határidőn belül, a jegyek mások számára felszabadításra kerülnek.`}
          </p>
          <p style={{ fontSize: '1.1rem', textAlign: 'center' }}>
            {t`Kérjük kezdd elölről a rendelésed!`}
          </p>
          <button
            type="button"
            className="search-button-style btn btn-secondary float-right"
            onClick={handleBackClick}
          >
            {t`Vissza`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TimeoutPage;
